export const languageCode = 'es';
export const languageLabel = 'Spanish';

export const translations = {
  AUDIO_DESCRIPTION_OFF: 'Apagado',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: 'Ocultar el menú de subtítulos',
  CAPTIONS_OFF: 'Apagado',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: 'Buscar vídeo',
  CAPTIONS_SHOW_MENU: 'Mostrar el menú de subtítulos',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: 'Cerrar capítulos',
  CHAPTERS_OPEN_CHAPTERS: 'Abrir capítulos',

  CLICK_FOR_SOUND_DESKTOP_TEXT: 'Hacer clic para escuchar el sonido',
  CLICK_FOR_SOUND_MOBILE_TEXT: 'Presionar para escuchar el sonido',

  CONTEXT_MENU_ABOUT_WISTIA: 'Sobre Wistia',
  CONTEXT_MENU_COPIED: '¡Copiado!',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: 'Copiar enlace y miniatura',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'Sesión iniciada en Wistia',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Abrir video en Wistia',
  CONTEXT_MENU_REPORT_A_PROBLEM: 'Informar de un problema',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'Ver estadísticas en Wistia',

  CUSTOMER_LOGO_LOGO: 'Logotipo',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: 'Desactivar la función "Pantalla completa"',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: 'Pantalla completa',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: 'Video',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: 'Reproducir',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: 'Pausar',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: 'Por favor, agregue detalles',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: 'Elegir uno',
  REPORT_A_PROBLEM_DESCRIPTION:
    'Gracias por informar de un problema. Adjuntaremos los datos técnicos sobre esta sesión para ayudarnos a resolver el problema. ¿Cuál de estas afirmaciones describe mejor el problema?',
  REPORT_A_PROBLEM_DISMISS: 'Descartar',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: 'El video no se reproduce',
  REPORT_A_PROBLEM_OTHER: 'Otros',
  REPORT_A_PROBLEM_OTHER_CONTEXT: '¿Algún otro detalle o contexto?',
  REPORT_A_PROBLEM_POOR_QUALITY: 'El video tiene mala calidad',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: 'Categoría de problema',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: 'Descripción del problema',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: 'Por favor, seleccione una categoría',
  REPORT_A_PROBLEM_SEND: 'Enviar',
  REPORT_A_PROBLEM_SENDING: 'Enviando...',
  REPORT_A_PROBLEM_STUTTER: 'El video se reproduce, pero con frecuencia presenta fluctuaciones',

  REWATCH: 'Volver a ver',

  SETTINGS_PLAYBACK_RATE_TITLE: 'Velocidad',
  SETTINGS_QUALITY_AUTO: 'Auto',
  SETTINGS_QUALITY_TITLE: 'Calidad',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: 'Cerrar el menú para compartir',
  SHARE_CONTROL_OPEN: 'Abrir el menú para compartir',
  SHARE_COPIED: '¡Copiado!',
  SHARE_DOWNLOAD: 'Descargar',
  SHARE_EMAIL: 'Correo electrónico',
  SHARE_EMBED: 'Incrustar',
  SHARE_FACEBOOK: 'Facebook',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',

  SKIP: 'Omitir',

  STATUS_BAR_EMBED_CODE_COPIED: 'El código de inserción se ha copiado en el portapapeles.',

  THUMBNAIL_VIDEO_THUMBNAIL: 'Video en miniatura',
  TURNSTILE_DEFAULT_END: '¡Gracias por verlo! \nIntroduce tu dirección de correo electrónico.',
  TURNSTILE_DEFAULT_START: 'Introduce tu dirección de correo electrónico para ver este vídeo.',
  TURNSTILE_EMAIL_PLACEHOLDER: 'Tu correo electrónico',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: 'Nombre',
  TURNSTILE_LAST_NAME_PLACEHOLDER: 'Apellidos',
  TURNSTILE_PLAY: 'Reproducir',
  TURNSTILE_SUBMIT: 'Enviar',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: 'Control de volumen',
  VOLUME_TITLE_WHEN_MUTED: 'Desactivar la función "Silenciar"',
  VOLUME_TITLE_WHEN_UNMUTED: 'Silenciar',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'El siguiente vídeo se reproducirá en...',
};
